// 常量类
export const LoginType = {
  google: 'google',
  wechat: 'wechat',
}

export const ResponseCode = {
  SUCCESS: 100000,
  LOGIN_FAILURE: 200001,
  LOGIN_GET_QRCODE_FAILURE: 200003,
  LOGIN_UNDO_SCAN_SUCCESS: 200004,
  LOGIN_SCAN_TIME_OUT: 200006,
  NOTLOGIN: 200007,
  AI_DRAW_CREATE_JOB_FAILURE: 300001,
  AI_DRAW_CHECK_CREDITS_FAILURE: 300002,
  AI_DRAW_PROMPTS_FAILURE: 300003,
  AI_DRAW_NOT_RESOURCE_FAILURE: 300004,
  AI_DRAW_SYSTEM_ERROR_FAILURE: 300005,
  AI_DRAW_IMAGE_PROGRESS: 300006,
  AI_DRAW_IMAGE_FAILURE: 300008,
  REACH_LIMIT: 400101,
  JOB_TIMEOUT: 400201,
  PARAM_ERROR: 400301,
}
// 轮询任务的执行状态
export const JobPollStatus = {
  RUNNING: false,
  STOP: true,
}

export const IsSandbox = {
  YES: '1',
  NO: '0',
}